import { useGT } from 'gt-react';
import type { TASK_PRIORITIES } from './workbookTaskRules';

/** A Task priority's label, as the Tasks pages name it. */
export function useTaskPriorityLabels(): Record<
  (typeof TASK_PRIORITIES)[number],
  string
> {
  const gt = useGT();
  return {
    low: gt('Low', { context: 'task priority' }),
    medium: gt('Medium', { context: 'task priority' }),
    high: gt('High', { context: 'task priority' }),
    urgent: gt('Urgent', { context: 'task priority' }),
  };
}

/** A Task status's label; an unknown status reads as itself. */
export function useTaskStatusLabel(): (status: string) => string {
  const gt = useGT();
  const labels: Record<string, string> = {
    pending: gt('Pending', { context: 'task status' }),
    in_progress: gt('In progress', { context: 'task status' }),
    needs_input: gt('Needs input', { context: 'task status' }),
    completed: gt('Completed', { context: 'task status' }),
    failed: gt('Failed', { context: 'task status' }),
    cancelled: gt('Cancelled', { context: 'task status' }),
  };
  return (status) => labels[status] ?? status;
}
